export const ReportStatusTypes = {
	INIT: 'INIT',
	RUNNING: 'RUNNING',
	ERROR: 'ERROR',
	SUCCESS: 'SUCCESS'
};


// WEBPACK FOOTER //
// ./src/views/components/report_status/reportStatusTypes.js